// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectNewsSelect_wrapper__ccR+W"};